import * as damageStatuses from '@/constants/damage_statuses';

export default {
  data() {
    return {
      useNullableDamageStatus: true,
    };
  },
  computed: {
    damageStatusesStatusItems() {
      const items = [];
      if (this.useNullableDamageStatus) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(damageStatuses)
        .forEach((key) => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.order_statuses.${damageStatuses[key]}`),
            value: damageStatuses[key],
          });
        });
      return items;
    },
  },
};
